import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { loadingBarApiInjectionKey as r } from "./context.js";
import { throwError as n } from "../../_utils/naive/warn.js";
import { inject as i } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function l() {
  const o = i(r, null);
  return o === null && n("use-loading-bar", "No outer <n-loading-bar-provider /> founded."), o;
}
export {
  l as useLoadingBar
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/loading-bar/src/use-loading-bar.js
// module id = 1710
// module chunks = 67